import DOMPurify from "dompurify";

/**
 * Sanitize user-provided text before sending to the server.
 * Strips all HTML/script tags and returns plain text to prevent XSS
 * when the server stores or echoes the value.
 * Decodes HTML entities (e.g. &amp; -> &) so user text like "A & B"
 * is stored and displayed correctly.
 *
 * Use for: comments, descriptions, feedback, additional instructions,
 * rule text, and any free-text input sent in API requests.
 *
 * @param input - Raw string from user input (can be undefined/null)
 * @returns Sanitized plain text, or empty string if input is falsy
 */
export function sanitizeUserInput(input: string | null | undefined): string {
  if (input == null || typeof input !== "string") {
    return "";
  }
  const clean = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }).trim();
  const doc = new DOMParser().parseFromString(clean, "text/html");
  return (doc.body.textContent ?? "").trim();
}
